<template>
    <div class="form-group" :class="{ 'form-row': horizontal }">
        <label
            v-if="label"
            :class="[
                { 'col-form-label': horizontal },
                horizontal ? classLabel : '',
            ]"
            >{{ label }}</label
        >
        <div :class="[horizontal ? classInput : '']">
            <vue-tags-input
                v-model="tagComponent"
                :tags="tagsComponent"
                @tags-changed="(newTags) => (tagsComponent = newTags)"
            />
        </div>
    </div>
</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";
import { isObjectEqual } from "~/helpers/index";

export default {
    name: "TagsInput",
    components: {
        VueTagsInput,
    },
    data() {
        return {
            tagComponent: "",
            tagsComponent: [],
            valueComponent: [],
            classLabel: "col-sm-3",
            classInput: "col-sm-9",
        };
    },
    props: {
        label: {
            type: String,
            default: null,
        },
        placeholder: {
            type: String,
            default: null,
        },
        isValid: {
            type: Boolean,
            default: null,
        },
        value: {
            type: Array,
            default: () => {
                return [];
            },
        },
        options: {
            type: Array,
            default: () => {
                return [];
            },
        },
        horizontal: {
            default: false,
        },
    },
    watch: {
        tagsComponent(newValue) {
            this.valueComponent = newValue.map((item) => {
                return item.text;
            });
        },
        valueComponent(newValue) {
            this.$emit("update:value", newValue);
            // this.$emit("change", newValue);
        },
        value(newValue, oldValue) {
            if (!isObjectEqual(newValue, oldValue)) {
                this.tagsComponent = this.parseValueToTags(newValue);
            }
        },
    },
    methods: {
        setHorizontalClass() {
            if (this.horizontal.label) {
                this.classLabel = this.horizontal.label;
            }
            if (this.horizontal.input) {
                this.classInput = this.horizontal.input;
            }
        },

        parseValueToTags(value) {
            return value.map((item) => {
                return {
                    text: item,
                    tiClasses: ["it-valid"],
                };
            });
        },
    },
    async mounted() {
        this.setHorizontalClass();
        this.tagsComponent = this.parseValueToTags(this.value);
    },
};
</script>

<style lang="scss">
@import "node_modules/bootstrap/scss/bootstrap.scss";

/** .multiselect.is-invalid {
    .multiselect__tags {
        @extend .form-control.is-invalid;
    }
}*/
</style>